import createApiRequest from '../axios/createApiRequest';

type ErrorObject = Error & {
  error_enum?: string;
};

export default async function fetcher<Data extends object>(
  path: string,
  options = {},
) {
  return createApiRequest<Data>({
    path,
    method: 'get',
    throwErrors: true,
    ...options,
  })
    .then((res: APIResponse<Data> | void) => res?.data)
    .catch((error: ErrorObject) => {
      const message =
        error && typeof error === 'object' && 'error_enum' in error
          ? (error.error_enum as string)
          : `fetch error for ${path}`;
      throw new Error(message, { cause: error });
    });
}
